export default __webpack_public_path__ + "../staticImages/productBoxWide-2x-bg.jpg";